import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { useAuth } from '@/provider/UserProvider';
import { fetchRoomMessage, postSendMessage } from '@/services/group-chat';

import type { IDataMessage } from './ItemChat';

export interface MessageInput {
  content: string;
  callback?: () => void;
}

const PAGE_SIZE = 20;

const useGroupChat = (isLoadingFirstTime?: boolean) => {
  const { isLogin } = useAuth();
  const listMessageRef = useRef([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [textInput, setTextInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<IDataMessage[]>([]);
  const [hasMore, setHasMore] = useState(true);

  function sleep(timeout: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, timeout);
    });
  }
  const addMoreItemMess = useCallback(
    (data: IDataMessage) => {
      setList((prevList) => [data, ...prevList]);
    },
    [],
  );


  const handleSendMessage = async (content: string, callback?: () => void) => {
    const hasStop = !content || loading;
    if (hasStop) return;
    setLoading(true);
    const [data] = await postSendMessage({ content });
    setLoading(false);
    if (data) {
      callback && callback();
    }
    await sleep(1000);
  };

  const onPostMessage = async ({ content, callback }: MessageInput) => {
    if (!isLogin) {
      toast.error('Please login to continue!');
      return;
    }
    if (isLogin) {
      handleSendMessage(content, callback);
    }
  };

  const getAllMessages = async (page: number) => {
    const [data]: any = await fetchRoomMessage({
      size: PAGE_SIZE,
      offset: PAGE_SIZE * (page - 1),
    });
    console.log(data, 'data');

    if (data?.items.length > 0) {
      if (page === 1) {
        listMessageRef.current = [];
        setList([]);
      }
      listMessageRef.current = listMessageRef.current.concat(data?.items || []);
      setList(listMessageRef.current);
    } else {
      setHasMore(false);
    }
  };

  const loadMoreMessage = (page: number) => {
    setCurrentPage(page);
    getAllMessages(page);
  };

  useEffect(() => {
    if (isLoadingFirstTime) {
      getAllMessages(1);
    }
  }, []);

  return {
    list,
    onPostMessage,
    setTextInput,
    textInput,
    currentPage,
    loading,
    loadMoreMessage,
    hasMore,
    addMoreItemMess,
    setList,
  };
};

export default useGroupChat;
